import { Upload, Search, FileCheck } from "lucide-react";

const steps = [
  {
    id: 1,
    icon: Upload,
    name: "Send the review pack",
    description: "The contractor supplies the tender documents, current estimate, key supplier/subcontract quotations, tender deadline and programme or methodology if available.",
  },
  {
    id: 2,
    icon: Search,
    name: "Blackline red-teams it",
    description: "AI supports document extraction, comparison and structured checks. Calculation logic is checked deterministically where possible. An experienced construction reviewer challenges and verifies material findings before release.",
  },
  {
    id: 3,
    icon: FileCheck,
    name: "Receive the decision report",
    description: "The customer receives an executive summary, prioritised findings, evidence references, RFIs/actions worth raising, a pre-submission checklist and a GO / GO WITH ACTIONS / HOLD conclusion.",
  },
];

export default function HowItWorksTender() {
  return (
    <section
      id="how-it-works"
      className="py-16 md:py-24 border-t-4 border-black bg-zinc-50"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-12 md:mb-16">
          <span className="font-mono text-sm uppercase tracking-widest text-zinc-500">
            Process
          </span>
          <h2
            className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl uppercase mt-4"
            data-testid="how-it-works-title"
          >
            How It Works
          </h2>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className="relative"
              data-testid={`step-${step.id}`}
            >
              {/* Connection line (desktop only) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[calc(50%+3rem)] w-[calc(100%-6rem)] h-0.5 bg-black" />
              )}

              <div className="flex flex-col items-center text-center">
                {/* Step number and icon */}
                <div className="relative mb-6">
                  <div className="w-24 h-24 border-4 border-black bg-white flex items-center justify-center">
                    <step.icon size={36} strokeWidth={1.5} />
                  </div>
                  <span className="absolute -top-3 -right-3 w-8 h-8 bg-black text-white font-mono text-sm flex items-center justify-center">
                    {step.id}
                  </span>
                </div>

                {/* Content */}
                <h3 className="font-heading font-bold text-xl uppercase mb-3">
                  {step.name}
                </h3>
                <p className="font-body text-zinc-600 leading-relaxed max-w-sm">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Caveat */}
        <div className="mt-12 p-6 border-2 border-zinc-300 bg-white text-center">
          <p className="font-body text-zinc-600 text-sm">
            <strong>Note:</strong> AI does not make the final commercial decision. The final tender and submission decision always remain with the customer.
          </p>
        </div>
      </div>
    </section>
  );
}
